import { useModal } from "hooks/useModal"
import { useAppDispatch } from "reducers/store"
import { SET_EVENT_TYPE_LIST } from "reducers/event-types/actions-types"
import ApiEventTypes from "api/ApiEventTypes"

import styled from "styled-components"
import { useCallback, memo } from "react"
import IconCreditCard from "components/EvtKit/icons/IconCreditCard"
import { setAccount } from "reducers/accounts/accounts-actions"

const InlineButton = styled.div`
  width: 25px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: 16px;
`

interface AddBalanceButtonProps {
  account: App.Account
}

const AddBalanceButton = (props: AddBalanceButtonProps) => {
  const { account } = props

  const appDispatch = useAppDispatch()

  const { openModal } = useModal()

  const setEventTypes = useCallback(async () => {
    const { events: eventTypes } = await new ApiEventTypes().filterByProduct(account.product)

    if (!eventTypes) return

    appDispatch({ type: SET_EVENT_TYPE_LIST, payload: eventTypes })
  }, [account, appDispatch])

  const handleOnClick = useCallback(async () => {
    await setEventTypes()
    appDispatch(setAccount(account))
    openModal("addProperty")
  }, [account, appDispatch, openModal, setEventTypes])

  return (
    <InlineButton onClick={handleOnClick}>
      <IconCreditCard />
    </InlineButton>
  )
}

export default memo(AddBalanceButton)
